/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {
  Component,
  computed,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';
import { CalendarCell, CommonUtils } from '@infodata-group/inf-commons';

@Component({
  selector: 'infl-calendar-cell',
  templateUrl: './calendar-cell.component.html',
  styleUrls: ['./calendar-cell.component.scss'],
  standalone: true,
  imports: [],
})
export class CalendarCellComponent {
  public cell = input<CalendarCell>();
  public enable = input(false);

  public dropTask = output<void>();

  protected mainDiv = viewChild<ElementRef>('elementDiv');

  public isCurrentDay = computed(() => {
    return CommonUtils.compareDate(this.cell().day.toDate(), new Date());
  });

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  drop() {
    this.dropTask.emit();
  }

  scrollIntoView() {
    this.mainDiv().nativeElement.scrollIntoView({ block: 'center' });
  }
}
